var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphanumeric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2189_603)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    fill: "#F4F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74707 12.8311C9.2028 12.8311 9.5651 12.7422 9.83398 12.5645C10.1074 12.3822 10.3057 12.1042 10.4287 11.7305C10.5518 11.3568 10.6156 10.8828 10.6201 10.3086V10.2129C10.6201 9.36523 10.4834 8.72038 10.21 8.27832C9.93652 7.83171 9.44434 7.6084 8.7334 7.6084C8.13184 7.6084 7.68522 7.83398 7.39355 8.28516C7.10189 8.73633 6.95605 9.39258 6.95605 10.2539C6.95605 11.1061 7.09961 11.7487 7.38672 12.1816C7.67839 12.6146 8.13184 12.8311 8.74707 12.8311ZM8.33691 14.1367C7.42546 14.1367 6.69173 13.8086 6.13574 13.1523C5.57975 12.4961 5.30176 11.5254 5.30176 10.2402C5.30176 8.95964 5.58431 7.9821 6.14941 7.30762C6.71452 6.63314 7.48926 6.2959 8.47363 6.2959C9.02507 6.2959 9.47852 6.39388 9.83398 6.58984C10.194 6.78581 10.4902 7.07747 10.7227 7.46484H10.8184C10.8548 7.30078 10.9095 7.12305 10.9824 6.93164C11.0599 6.74023 11.151 6.57389 11.2559 6.43262H12.5684C12.5 6.6377 12.4339 6.90202 12.3701 7.22559C12.3063 7.54915 12.2539 7.90234 12.2129 8.28516C12.1719 8.66341 12.1514 9.04167 12.1514 9.41992V11.9629C12.1514 12.2773 12.2083 12.4961 12.3223 12.6191C12.4362 12.7376 12.5752 12.7969 12.7393 12.7969C12.8076 12.7969 12.8828 12.79 12.9648 12.7764C13.0514 12.7581 13.1152 12.7399 13.1562 12.7217V13.959C13.1107 13.9863 13.04 14.0137 12.9443 14.041C12.8486 14.0684 12.7438 14.0911 12.6299 14.1094C12.516 14.1276 12.4089 14.1367 12.3086 14.1367C11.8984 14.1367 11.568 14.0524 11.3174 13.8838C11.0667 13.7152 10.8799 13.4076 10.7568 12.9609H10.6406C10.4993 13.1751 10.3262 13.3711 10.1211 13.5488C9.92057 13.7266 9.67448 13.8701 9.38281 13.9795C9.09115 14.0843 8.74251 14.1367 8.33691 14.1367Z",
    fill: "#191A20"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 2.5,
    stroke: "#E1E0DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2189_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphanumeric);
export default __webpack_public_path__ + "static/media/alphanumeric.fb2fa154589d2f0b6259b2d608cc8326.svg";
export { ForwardRef as ReactComponent };